import { useEffect, useState } from "react";

import { ProposalMatching } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";

interface UseGetProposalMatchings {
  proposalMatchings: ProposalMatching[];
  loading: boolean;
}

export const useGetProposalMatchings = (): UseGetProposalMatchings => {
  const [proposalMatchings, setProposalMatchings] = useState<ProposalMatching[]>([]);
  // マウント直後（fetch 開始前）の1レンダーも「未確定」として扱えるよう true で初期化する。
  // false 始まりだと初回描画時に「マッチなし」と区別できず、ホームのセクション順が応答後に入れ替わる
  const [loading, setLoading] = useState<boolean>(true);

  const fetchProposalMatchings = async () => {
    try {
      setLoading(true);

      const fp = PropallyApiFactory();
      const response = await fp.v1ProposalMatchingsGet({
        withCredentials: true,
      });
      setProposalMatchings(response.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProposalMatchings();
  }, []);

  return { proposalMatchings, loading };
};
